import React from "react";
import { useTranslation } from "react-i18next";

export default function LegalLayout({ titleKey, updatedKey, children }) {
  const { t } = useTranslation();
  return (
    <main id="main" className="pt-[120px] md:pt-[160px] pb-24">
      <div className="zv-container max-w-[880px]">
        <div className="zv-mono-tag text-[#c8622a] mb-4">Legal</div>
        <h1 className="zv-serif text-5xl md:text-7xl leading-[1] mb-4">{t(titleKey)}</h1>
        <div className="text-[13px] text-[#0d1117]/60 mb-10">{t(updatedKey)}</div>
        <div className="zv-prose">{children}</div>
      </div>
    </main>
  );
}
